import { Component, OnInit } from '@angular/core';
import {DataService} from '../../services/data.service';


@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.css']
})
export class CategoriesComponent implements OnInit {

  postsData:any[];
  posts:Post[];
  newsData:any[];
  news:Post[];
  newsIntervalFunction:any;
  newsIntervalID:any;
  scrollXIncrement:Number = 1;
  intervalCounter:Number=0;
  scrollLimit:Number = 7300;
  coordY:Number;
  last: boolean;
  windowSize:Number=0;
  

 
    constructor(private dataService:DataService) { 
    
      this.newsIntervalFunction= function(x) {
        let ScrollXOffset=window.document.getElementById("news-ticker").scrollLeft;

        if(ScrollXOffset!= this.intervalCounter * this.scrollXIncrement) { // if scrollbar had been dragged
          // alert("interval stopped!");
          clearInterval(this.newsIntervalID);
        }
        this.intervalCounter++;
        window.document.getElementById("news-ticker").scrollLeft +=this.scrollXIncrement;
      }

      this.newsIntervalID = setInterval(() => {
        this.newsIntervalFunction(); 
        if(window.document.getElementById("news-ticker").scrollLeft>this.scrollLimit) {
        // alert("interval stopped!");
          clearInterval(this.newsIntervalID);
        }
      }, 20);
    }

    ngOnInit() {
      this.dataService.getPosts("categories").subscribe((post)=>{
        console.log(post);
        this.posts=post;
        this.postsData = this.posts;
      });
  
      this.dataService.getPosts("news").subscribe((news)=>{
        console.log(news);
        this.news=news;
        this.newsData = this.news;
        this.scrollLimit=100+(this.newsData.length*200);
      });
    }
 

    news_onClick(e) {
      clearInterval(this.newsIntervalID);
    //  window.document.getElementById('news-ticker').style.height="200px";
    }


}




interface Post {

  
}






// WEBPACK FOOTER //
// C:/Users/calvi/Documents/AngularProjects/calvinparksportfolio/src/app/components/categories/categories.component.ts